import Api from '@/vuex/api'
import {
  SET_EPMA_ACTIONS,
  DELETE_EPMA,
  EDIT_EPMA,
  MAIL_EPMA,
  INVOICE_EPMA,
  REQUEST_EPMA_SIGNATURE,
  OPEN_MODAL,
  GENERATE_COMPANY_PORTFOLIO,
  VIEW_COMPANY_PORTFOLIO
} from '@/vuex/types'

const api = new Api()
const state = {
  epma: {
    uuid: '',

    Company: {},

    totalLots: 0,
    attachmentsTotal: 0,

  },
  EPMAActions: [
    { label: 'Edit EPMA', command: EDIT_EPMA, icon: 'fa fa-edit' },

    // { label: 'Upload contract', command: UPLOAD_EPMA_CONTRACT, icon: 'fa fa-upload' },
    { label: 'Request Signature', command: REQUEST_EPMA_SIGNATURE, icon: 'fa fa-fw fa-check-square' },
    { label: 'Send Email', command: MAIL_EPMA, icon: 'fa fa-envelope' },
    { label: 'Create Invoice Request', command: INVOICE_EPMA, icon: 'fa fa-fw fa-dollar-sign' },
    { label: 'Create Portfolio', command: GENERATE_COMPANY_PORTFOLIO, icon: 'fa fa-plus' },
    { label: 'View Portfolio', command: VIEW_COMPANY_PORTFOLIO, icon: 'fa fa-sticky-note' },
    { label: 'Delete EPMA', command: DELETE_EPMA, icon: 'fa fa-trash-alt' }
  ],
}

const getters = {
  EPMAActions ({ EPMAActions }) {
    return EPMAActions
  },
  epmaActions ({ epmaActions }) {
    return epmaActions
  },
  loadedEPMA ({ epma }) {
    return epma
  },

}


const mutations = {
  [SET_EPMA_ACTIONS] (state) {
    if (state.EPMAActions.find(item => item.label === 'Select Preferred Contractors')) {
      state.EPMAActions.splice(3, 1)
    }
  },

}

const actions = {

  async [EDIT_EPMA] (context, epma) {
    let editEPMAModal = {
      permalink: 'editEPMA',
      options: {
        title: 'Edit EPMA',
        actionLabel: 'Save'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editEPMAModal)
  },
  async [MAIL_EPMA] (context, epma) {
    let sendEPMAEmailModal = {
      permalink: 'sendEPMAEmail',
      options: {
        title: 'send EPMA email',
        actionLabel: 'Send'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, sendEPMAEmailModal)
  },
  async [INVOICE_EPMA] (context, epma) {
    let invoiceEPMAModal = {
      permalink: 'invoiceEPMA',
      options: {
        title: 'Invoice EPMA',
        actionLabel: 'Send'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, invoiceEPMAModal)
  },
  async [REQUEST_EPMA_SIGNATURE] (context, epma) {
    let requestEPMASignatureModal = {
      permalink: 'requestEPMASignature',
      options: {
        title: 'Request EPMA Signature',
        actionLabel: 'Request'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, requestEPMASignatureModal)
  },

  async [GENERATE_COMPANY_PORTFOLIO] (context, epma) {
    let generateCompanyPortfolioModal = {
      permalink: 'generateCompanyPortfolio',
      options: {
        title: 'Generate Property portfolio list for Company',
        actionLabel: 'Generate'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, generateCompanyPortfolioModal)
  },

  async [VIEW_COMPANY_PORTFOLIO] (context, epma) {
    let viewCompanyPortfolioModal = {
      permalink: 'viewCompanyPortfolio',
      options: {
        title: 'View Portfolio',
        actionLabel: 'Save'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, viewCompanyPortfolioModal)
  },
  async [DELETE_EPMA] (context, epma) {
    let deleteEPMAModal = {
      permalink: 'deleteEPMA',
      options: {
        title: 'Delete EPMA',
        actionLabel: 'Delete'
      },
      params: {
        uuid: epma.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteEPMAModal)
  },
  
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/epma.js